import { combineReducers } from "redux";
import transactionsReducer from "./slices/transactions/transSlice";
import errorReducer from "./slices/errors/errorsSlice";

const rootReducer = combineReducers({
  transactions: transactionsReducer,
  error: errorReducer,
});

export default rootReducer;
